import { Component, Input, EventEmitter, Output } from '@angular/core';
import { WidgetMode } from '../abstract-widget.component';

@Component({
    selector: 'app-widget-app-image',
    templateUrl: './widget-app-image.component.html',
    styleUrls: ['./widget-app-image.component.scss'],
    imports: []
})
export class WidgetAppImageComponent {

  @Input()
  public imagePath: string;

  @Input()
  public url: string;

  @Input()
  public mode = WidgetMode.View;

  @Output()
  public delete = new EventEmitter<void>();

  protected WidgetMode = WidgetMode;

  constructor() {}

  public onDelete() {
    this.delete.emit();
  }

  public onClickPicture(event) {
    if (this.mode === WidgetMode.Edit) {
      return;
    }
    window.open(this.url)
  }
}
